import QuickviewCanvasHeaderTemplate from '../../../../../../Template/theme/components/quickview/Quickview/QuickviewCanvasContainer/QuickviewCanvasHeader'

export default theme => {
    return {
        ...QuickviewCanvasHeaderTemplate(theme)
    }
}


// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/theme/components/quickview/Quickview/QuickviewCanvasContainer/QuickviewCanvasHeader.js